var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-dropdown",
    {
      staticClass: "w-100",
      attrs: {
        variant: _vm.buttonVariant,
        disabled: _vm.statusInProgressOrLoading || _vm.disabled,
        "no-caret": _vm.statusInProgressOrLoading || _vm.disabled,
        "toggle-class": "btn-sm",
      },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function () {
            return [
              _vm.loading
                ? _c("inline-loader", {
                    staticClass: "mr-1",
                    attrs: { variant: "white" },
                  })
                : _c("span", [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.translatedStatus) +
                        "\n      " +
                        _vm._s(
                          _vm.partialSync
                            ? " - " +
                                _vm.$t("filogix.expertSync.partiallySynced")
                            : ""
                        ) +
                        "\n    "
                    ),
                  ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          on: {
            click: function ($event) {
              return _vm.handleStatusChange("accepted")
            },
          },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("filogix.dealStatuses.accepted")) + "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          on: {
            click: function ($event) {
              return _vm.handleStatusChange("approved")
            },
          },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("filogix.dealStatuses.approved")) + "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          on: {
            click: function ($event) {
              return _vm.handleStatusChange("confirmed")
            },
          },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("filogix.dealStatuses.confirmed")) + "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          on: {
            click: function ($event) {
              return _vm.handleStatusChange("ready-to-close")
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("filogix.dealStatuses.readyToClose")) +
              "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }